/* global google */

(() => {
  let devReachMap;
  let info;
  let marker;
  const devReachMap2021 = document.querySelector('.devReachMap--2021');
  const nodes = Array.from(document.querySelectorAll('.js-address'));

  if (nodes.length === 0) return;

  const incMaps = document.createElement('script');

  function getCoords(node) {
    const LAT = parseFloat(node.getAttribute('data-latitude'));
    const LNG = parseFloat(node.getAttribute('data-longitude'));
    return [LAT, LNG];
  }

  function displayInfoWindow() {
    info.open(devReachMap, marker);
  }

  function setInfoWindow(node) {
    const link = node.parentElement.querySelector('.js-register') ? node.parentElement.querySelector('.js-register').getAttribute('href') : null;
    const anchorEl = link ? `<a href="${link}" class="-dib -tdu -c-blue -ttu">Register Now</a>` : '';

    const content = devReachMap2021 ? `<div class="devReachMap-pinbox">
      <div class="-ff-base" style="margin-bottom:5px;font-size:1.1em;">${node.innerText}</div>
      <div class="-mb1">${node.getAttribute('data-address')}</div>${anchorEl}</div>` : `<div class="devReachMap-pinbox">
      <div style="font-weight:bold;margin-bottom:5px;font-size:1.13em;">${node.innerText}</div>
      ${node.getAttribute('data-address')}</div>`;

    info.setContent(content);
  }

  function createMap(node, multiplePins = false) {
    const pin2019 = 'https://www.telerik.com/sfimages/default-source/devreach/drpin.png';
    const pin2020 = 'https://www.telerik.com/sfimages/default-source/devreach/2020/drpinus.png';

    const ICON = (document.querySelector('.devReachMap').classList.contains('devReachMap--US2020')) ? pin2020 : pin2019;

    const LAT = multiplePins ? getCoords(node[0])[0] : getCoords(node)[0];
    const LNG = multiplePins ? getCoords(node[0])[1] : getCoords(node)[1];
    const TITLE = multiplePins ? node[0].innerText : node.innerText;

    devReachMap = new google.maps.Map(document.querySelector('.devReachMap'), {
      center: new google.maps.LatLng(30, -30),
      zoom: 15,
      mapTypeControl: true,
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_CENTER,
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        mapTypeIds: [
          google.maps.MapTypeId.ROADMAP,
          google.maps.MapTypeId.SATELLITE
        ]
      },
      fullscreenControlOptions: { position: google.maps.ControlPosition.BOTTOM_RIGHT }
    });

    function createMarkers(item, lat = LAT, lng = LNG, title = TITLE) {
      marker = new google.maps.Marker({
        map: devReachMap,
        position: new google.maps.LatLng(lat, lng),
        title,
        icon: ICON
      });

      devReachMap.zoom = 2.75;

      marker.addListener('click', () => {
        if (info) info.close();

        info = new google.maps.InfoWindow();
        setInfoWindow(item);

        if (multiplePins) {
          marker.setPosition(new google.maps.LatLng(lat, lng));
          devReachMap.panTo(new google.maps.LatLng(lat, lng));
        }

        displayInfoWindow();
      });
    }

    if (multiplePins) {
      for (let i = 0; i < node.length; i++) {
        const nodeLAT = getCoords(node[i])[0];
        const nodeLNG = getCoords(node[i])[1];
        const nodeTITLE = node[i].innerText;

        createMarkers(node[i], nodeLAT, nodeLNG, nodeTITLE);
      }
    }
    else {
      createMarkers(node);
    }
  }

  function moveMarker(node) {
    const LAT = getCoords(node)[0];
    const LNG = getCoords(node)[1];
    marker.setPosition(new google.maps.LatLng(LAT, LNG));
    devReachMap.panTo(new google.maps.LatLng(LAT, LNG));
    setInfoWindow(node);
    // uncomment next line to display infoWindow by default when switching venues
    // displayInfoWindow();
    nodes.forEach(nodeItem => nodeItem.classList.remove('is-active'));
    node.classList.add('is-active');
  }

  function registerHandlers(node) {
    node.addEventListener('click', moveMarker.bind(null, node), false);
  }

  window.DR_InitMaps = () => {
    if (devReachMap2021) {
      const locations2021 = Array.from(document.querySelectorAll('.js-address'));
      createMap(locations2021, true);
    }
    else {
      nodes.forEach(registerHandlers);
      createMap(document.querySelector('.js-address.is-active'));
    }
  };

  incMaps.async = 'true';
  incMaps.defer = 'true';
  incMaps.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD7j4B00nfIP_DQ5weAXyNNi8T-mvrnEQ8&callback=DR_InitMaps';
  document.body.prepend(incMaps);
})();
